module.exports = __webpack_public_path__ + "static/assets/133e4aa38e1bf1623a771873b842dabc.png";